import ng from "angular";
import { AgGridService } from "@topline/services/agGridService";
import { ImsIoMarketDataProvider } from "../services/imsIoMarketDataProvider";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { Gen } from "@topline/services/api";
import { GridOptions } from "ag-grid-community";

class FileMarketSkusComponentController {
    static $inject = [
        ImsIoMarketDataProvider.componentName,
        AgGridService.componentName,
        angularServicesNames.$translate,
        "$scope"
    ];
    public filters: Gen.MarketFilterDTO[];
    public countryCode: string;
    private gridApi: $TSFixMe;
    public serverOperation: ng.IPromise<Gen.ImsProductDTO[]>;

    constructor(
        private imsIoMarketDataProvider: ImsIoMarketDataProvider,
        private agGridService: AgGridService,
        private $translate: ng.translate.ITranslateService,
        private $scope: ng.IScope
    ) { }

    public $onInit(): void {
        this.$scope.$watchCollection("$ctrl.filters", () => this.refreshGrid());
        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));
        this.$scope.$watch(() => this.countryCode, () => this.refreshGrid());
    }

    private refreshGrid(): void {
        if (!this.gridApi) {
            return;
        }

        if (this.countryCode && this.filters && this.filters.length > 0) {
            this.serverOperation = this.imsIoMarketDataProvider
                .getImsProductByMarketFilter(this.filters, this.countryCode)
                .then(items => this.gridApi.setRowData(items));
        } else {
            this.gridApi.setRowData([]);
        }
    }

    public fileMarketSkusGridOptions: GridOptions = {
        columnDefs: [
            {
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.BRAND"),
                field: "brand",
                cellRenderer: "agGroupCellRenderer",
                rowGroup: true
            },
            {
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.MARKET"),
                field: "perscirptionMarket",
                filter: "agSetColumnFilter"
            },
            {
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.COMPANY"),
                field: "company",
                filter: "agSetColumnFilter"
            },
            {
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.MOLECULES"),
                field: "molecules",
                filter: "agSetColumnFilter",
                cellRenderer: () =>
                    '<div class="ui-grid-cell-contents" title="{{ data.molecules | join: \',\' }}"><span ng-repeat-start="m in data.molecules">{{m}}<span ng-if="!$last">, </span></span><span ng-repeat-end=""></span></div>'
            },
            {
                field: "sku",
                filter: "agTextColumnFilter",
                filterParams: {
                    newRowsAction: "keep"
                },
                enableRowGroup: true
            },
            {
                field: "pharmacyMarket",
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.PHARMACY_MARKET"),
                filter: "agSetColumnFilter"
            },
            {
                field: "atcOtc3",
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC3"),
                filter: "agSetColumnFilter"
            },
            {
                field: "atcOtc4",
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC4"),
                filter: "agSetColumnFilter"
            },
            {
                field: "nfc3",
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.NFC3"),
                filter: "agSetColumnFilter"
            },
            {
                field: "productCode",
                headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.ORACLE_INDEX"),
                filter: "agSetColumnFilter",
                enableRowGroup: false
            }
        ],
        angularCompileRows: true,
        animateRows: true,
        defaultColDef: {
            sortable: true,
            resizable: true,
            filterParams: {
                newRowsAction: "keep"
            },
            enableRowGroup: true
        },
        floatingFilter: true,
        suppressMultiSort: true,
        domLayout: "autoHeight",
        rowGroupPanelShow: "always",
        pagination: true,
        paginationPageSize: 20,
        groupUseEntireRow: true,
        localeTextFunc: this.agGridService.transalteFunc,
        suppressHorizontalScroll: true,
        suppressDragLeaveHidesColumns: true,
        onGridReady: config => {
            this.gridApi = config.api;
            config.api.sizeColumnsToFit();
            this.refreshGrid();
        },
        onGridSizeChanged: config => {
            config.api.sizeColumnsToFit();
        }
    };
}

export class FileMarketSkusComponent implements ng.IComponentOptions {
    static componentName = "fileMarketSkus";
    bindings = {
        filters: "<",
        countryCode: "<"
    };
    controller = FileMarketSkusComponentController;
    template = require("./fileMarketSkusComponent.html");
}

angular.module("topline.modules").component(FileMarketSkusComponent.componentName, new FileMarketSkusComponent());
